import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getAddGhostContactStyles = (theme: Theme, isWeb?: boolean) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.colors.background,
    },
    form: {
      padding: theme.spacing.lg,
    },
    fixedWidth: {
      width: 400,
    },
    marginRight: {
      marginRight: 50,
    },
    textPhoto: {
      textAlign: 'center'
    },
    scopeContainer: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    input: {
      marginBottom: theme.spacing.md,
    },
    footer: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      padding: theme.spacing.lg,
      alignSelf: 'flex-end',
    },
    genderContainer: {
      flexDirection: 'row',
      marginHorizontal: theme.spacing.lg,
      marginBottom: theme.spacing.lg,
      marginTop: theme.spacing.lg,
      borderRadius: 50,
      backgroundColor: '#F5F5F5',
      height: isWeb? undefined : 56,
    },
    genderButton: {
      flex: 1,
      paddingVertical: theme.spacing.sm,
      paddingHorizontal: theme.spacing.xl,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 50,
      width: isWeb? 150 : undefined
    },
    genderButtonSelected: {
      backgroundColor: theme.colors.primary,
    },
    tagsContainer: {
      flexWrap: 'wrap',
      flexDirection: 'row',
      marginTop: theme.spacing.md,
    },
    tagButton: {
      flexDirection: 'row',
      alignItems: 'center',
      marginRight: theme.spacing.sm,
      marginBottom: theme.spacing.sm,
      borderWidth: 1,
      borderRadius: theme.border.extraLarge,
      borderColor: theme.colors.primary,
      paddingVertical: theme.spacing.xs,
      paddingHorizontal: theme.spacing.sm,
      backgroundColor: theme.colors.white,
    },
    disponibilityBackground: {
      padding: theme.spacing.lg,
      backgroundColor: theme.colors.white,
      borderRadius: theme.border.jumbo,
      borderWidth: 1,
      borderColor: theme.colors.lightGrey,
      marginBottom: theme.spacing.lg,
    },
    disponibilityContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    editIcon: {
      position: 'absolute',
      right: theme.spacing.md,
      top: theme.spacing.md,
    },
    disponibilityItem: {
      marginRight: theme.spacing.sm,
      marginBottom: theme.spacing.sm,
    },
    title: {
    },

    bestMomentsSection: {
      paddingVertical: theme.spacing.lg,
    },
    bestMomentsTitle: {
      marginBottom: theme.spacing.lg,
    },
    bestMomentsScroll: {
      flexGrow: 0,
    },
    bestMomentsScrollContent: {
      paddingRight: theme.spacing.lg,
    },
    bestMomentItem: {
      alignItems: 'center',
      marginRight: theme.spacing.xl,
      minWidth: 80,
    },
    bestMomentLabel: {
      marginTop: theme.spacing.sm,
      textAlign: 'center',
    },
    marginTop: {
      marginTop: theme.spacing.lg,
    },
  }) 